var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.895508V8.89551H27.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 12.8955V8.89551L19.5 0.895508H3.5V12.8955",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 26.8955V30.8955H27.5V26.8955",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.643 19.0006C12.643 19.6386 12.455 20.1316 12.079 20.4796C11.703 20.8276 11.168 21.0006 10.475 21.0006H10.041V22.8956H8.49805V17.1846H10.475C11.196 17.1846 11.738 17.3416 12.1 17.6576C12.462 17.9736 12.643 18.4196 12.643 19.0006ZM10.041 19.7436H10.322C10.554 19.7436 10.738 19.6786 10.875 19.5486C11.012 19.4186 11.08 19.2386 11.08 19.0096C11.08 18.6236 10.867 18.4316 10.439 18.4316H10.041V19.7436Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 19.9186C18.4 20.8716 18.138 21.6066 17.613 22.1216C17.088 22.6366 16.351 22.8956 15.4 22.8956H13.552V17.1846H15.529C16.446 17.1846 17.154 17.4186 17.652 17.8876C18.15 18.3566 18.4 19.0336 18.4 19.9186ZM16.799 19.9736C16.799 19.4506 16.695 19.0626 16.488 18.8096C16.281 18.5566 15.967 18.4306 15.545 18.4306H15.096V21.6296H15.44C15.909 21.6296 16.252 21.4936 16.471 21.2216C16.69 20.9496 16.799 20.5336 16.799 19.9736Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9431 22.8956H19.4231V17.1846H22.7981V18.4226H20.9431V19.5126H22.6541V20.7506H20.9431V22.8956Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 12.8955H0.5V26.8955H30.5V12.8955Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.b45040a4c4c27dbe5003adbc90045fbd.svg";
export { ForwardRef as ReactComponent };